// export const downloadCSV = (data, fileName = "report.csv") => {
//   if (!data || data.length === 0) return;

//   const headers = Object.keys(data[0]);

//   const csvRows = [
//     headers.join(","),
//     ...data.map((row) =>
//       headers
//         .map(
//           (field) => `"${(row[field] ?? "").toString().replace(/"/g, '""')}"`
//         )
//         .join(",")
//     ),
//   ];

//   const csvString = csvRows.join("\n");

//   const encodedUri =
//     "data:text/csv;charset=utf-8," + encodeURIComponent(csvString);

//   const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

//   // ✅ DESKTOP (works fine)
//   if (!isMobile) {
//     const link = document.createElement("a");
//     link.href = encodedUri;
//     link.download = fileName;

//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   } else {
//     // ✅ MOBILE FIX (important)
//     const newWindow = window.open(encodedUri, "_blank");

//     if (!newWindow) {
//       alert("Please allow popups to download the file.");
//     }
//   }
// };
export const downloadCSV = (data, fileName = "report.csv") => {
  if (!data || data.length === 0) return;

  // Get headers
  const headers = Object.keys(data[0]);

  // Convert data to CSV
  const csvRows = [
    headers.join(","),
    ...data.map((row) =>
      headers
        .map(
          (field) => `"${(row[field] ?? "").toString().replace(/"/g, '""')}"`
        )
        .join(",")
    ),
  ];

  const csvString = csvRows.join("\n");

  // ✅ Check if running inside Flutter WebView
  const isFlutterWebView =
    window?.Flutter?.postMessage || window?.flutter_inappwebview?.callHandler;

  if (isFlutterWebView) {
    const payload = {
      type: "downloadCSV",
      fileName,
      data: csvString,
    };

    // webview_flutter
    if (window?.Flutter?.postMessage) {
      window.Flutter.postMessage(JSON.stringify(payload));
    }

    // flutter_inappwebview
    if (window?.flutter_inappwebview?.callHandler) {
      window.flutter_inappwebview.callHandler("downloadCSV", payload);
    }

    return;
  }

  // ✅ Normal Browser Download
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
